"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
const Text_1 = __importDefault(require("./Text"));
exports.default = (0, styled_components_1.styled)(Text_1.default) `
  opacity: ${({ opacity }) => (opacity ? opacity : 0.7)};
  font-style: italic;
`;
//# sourceMappingURL=Subtle.js.map